export var tooltipPortalTokens = {
  backgroundColor: function backgroundColor(_ref) {
    var palette = _ref.palette;
    return palette.neutralsBlack.rgba90;
  },
  color: function color(_ref2) {
    var palette = _ref2.palette;
    return palette.neutralsWhite.rgba90;
  },
  padding: 8,
  borderRadius: 4
};